import { retrieveFromServer } from './AwCrudService';

export function getLogItems(filter) {
	return retrieveFromServer(`items/${JSON.stringify(filter)}`);
}

export function getLoggedApps() {
	return retrieveFromServer('app-list');
}
